/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Missing_In_Out_ToastInputs */



/**
* | output |
* | --- |
* | "In and Out times of Event not set." |
*
* @param {Audio_Description_Missing_In_Out_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_missing_in_out_toast = /** @type {((inputs?: Audio_Description_Missing_In_Out_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Missing_In_Out_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les temps d'entree et de sortie de l'evenement ne sont pas definis.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eintritts- und Austrittszeiten der Veranstaltung nicht festgelegt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gli orari di entrata e uscita dell'evento non sono impostati.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Время входа и выхода события не задано.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Horas de entrada y salida del evento no establecidas.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件的开始和结束时间未设置。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの開始時間と終了時間が設定されていません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम के शुरू और खत्म होने का समय निर्धारित नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Horários de entrada e saída do evento não definidos.")
	return /** @type {LocalizedString} */ ("In and Out times of Event not set.")
});